// extracted by mini-css-extract-plugin
export default {"container":"components-__styles__-CompatibilityCheck-module__container"};